module.exports = {"path":"/404.html","body":"<h1>404 NOT FOUND</h1>\n<p>Whoops. This is awkward.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 513
// module chunks = 0